import { useQuery } from '@apollo/client';
import { useCallback, useRef, useState } from 'react';
import {
  GET_DSP_DELIVERY_COMPLETED_DETAIL_PAGE_LIST,
  GetDspDeliveryCompletedDetailPageListResponse,
  DspDeliveryCompletedDetailType,
  DspDeliveryCompletedDetailFilterType,
  DspDeliveryCompletedDetailPageRequestType,
} from '../queries/getDspDeliveryCompletedDetailList';

interface PaginationState {
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export function useDspDeliveryCompletedDetailQuery() {
  const [pageRequest, setPageRequest] = useState<DspDeliveryCompletedDetailPageRequestType | null>(null);
  const hasInitializedRef = useRef(false);

  const { data, loading, refetch } = useQuery<GetDspDeliveryCompletedDetailPageListResponse>(
    GET_DSP_DELIVERY_COMPLETED_DETAIL_PAGE_LIST,
    {
      variables: pageRequest ? { pageRequest } : undefined,
      skip: !pageRequest,
      fetchPolicy: 'network-only',
    }
  );

  const records: DspDeliveryCompletedDetailType[] =
    data?.getDspDeliveryCompletedDetailPageList?.pageResponse?.content ?? [];

  const pageData = data?.getDspDeliveryCompletedDetailPageList?.pageResponse;
  const pagination: PaginationState = {
    page: pageData?.page ?? 1,
    size: pageData?.size ?? 10,
    totalElements: pageData?.totalElements ?? 0,
    totalPages: pageData?.totalPages ?? 0,
    hasNext: pageData?.hasNext ?? false,
    hasPrevious: pageData?.hasPrevious ?? false,
  };

  const handleFilter = useCallback(
    async (filter: DspDeliveryCompletedDetailFilterType, page: number, size: number) => {
      const next: DspDeliveryCompletedDetailPageRequestType = {
        filter,
        pageRequest: {
          page,
          size,
          sortBy: 'deliveredDate',
          sortDirection: 'DESC',
        },
      };

      setPageRequest(next);
      // 第一次设置 pageRequest 时，useQuery 会从 skip→run 自动发起请求；无需手动 refetch
      // 之后（分页/切换过滤）才用 refetch，避免由于 handleFilter 引用变化导致的 effect 循环请求
      if (hasInitializedRef.current) {
        await refetch({ pageRequest: next });
      } else {
        hasInitializedRef.current = true;
      }
    },
    [refetch]
  );

  return {
    records,
    loading,
    pagination,
    handleFilter,
  };
}

